/**
 * Header Component
 * AI3D Fab-in-Place branding and navigation
 */

export function Header() {
  return (
    <header className="bg-fab-dark border-b border-slate-700 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3">
            <span className="text-3xl">🔧</span>
            <div>
              <h1 className="text-xl font-bold text-white">
                AI3D Fab-in-Place
              </h1>
              <p className="text-xs text-slate-400">
                Lovable for AI-generated 3D assets
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-white transition-colors text-sm"
          >
            Docs
          </a>
          <div className="flex items-center gap-2 text-xs text-slate-500">
            <span className="w-2 h-2 bg-fab-success rounded-full animate-pulse" />
            Powered by Raindrop + Vultr
          </div>
        </div>
      </div>
    </header>
  );
}
